module.exports = __webpack_public_path__ + "img/Hos_zhaowai.3850e06b.png";